/**
 * Do not remove
 * This indicates locale-specific pre-processor which filename to use before building
 * Renaming is done by prepareLocale yarn script and should be run on every locale change
 * @pragma filename('resort.historical-snowfall')
 */
import { ResortLayout } from 'page-components/resort/_layout';
import Component, { getResortHistoricalSnowfallPageServerSideProps } from 'page-components/resort/historical-snowfall';
import { propsWithI18NSSR } from 'util/propsWithI18n';
/* import { fetchResortSlugs } from 'util/fetchResortSlugs';
import { isMainLocale } from 'util/i18nFlags';
import { packPaths } from 'util/packPaths'; */

export default Object.assign(Component, { Layout: ResortLayout });

export const getServerSideProps = propsWithI18NSSR(getResortHistoricalSnowfallPageServerSideProps);

/* export const getStaticPaths = async () => packPaths(
  isMainLocale() ? (await fetchResortSlugs('resort.historical-snowfall')).map((res) => ({
    region: res.region,
    resort: res.slug,
  })) : [],
); */
